import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './AutoplayCarousel.css';

const cx = classnames.bind(styles);

function AutoplayCarousel({ children, className, delay, speed }) {
    const slides = React.Children.toArray(children);
    const extended = [...slides, React.cloneElement(slides[0], { key: 'clone' })];

    const [index, setIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(true);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex(prev => prev + 1);
        }, delay);

        return () => clearInterval(interval);
    }, [delay]);

    useEffect(() => {
        if (!isTransitioning) {
            const frame = requestAnimationFrame(() => {
                requestAnimationFrame(() => setIsTransitioning(true));
            });

            return () => cancelAnimationFrame(frame);
        }
    }, [isTransitioning]);

    const handleTransitionEnd = (e) => {
        if (e.target !== e.currentTarget) return;

        if (index >= slides.length) {
            setIsTransitioning(false);
            setIndex(0);
        }
    };

    return (
        <div className={cx('root', { [className]: Boolean(className) })}>
            <div
                className={styles.track}
                style={{
                    transform: `translateX(calc(-${index} * (100% + 8px)))`,
                    transition: isTransitioning ? `transform ${speed}ms ease` : 'none'
                }}
                onTransitionEnd={handleTransitionEnd}
            >
                {extended.map(slide => (
                    <div className={styles.slide} key={slide.key}>
                        {slide}
                    </div>
                ))}
            </div>
        </div>
    );
}

AutoplayCarousel.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    delay: PropTypes.number,
    speed: PropTypes.number
};

AutoplayCarousel.defaultProps = {
    className: '',
    delay: 3000,
    speed: 600
};

export {
    AutoplayCarousel
};
